import requestApi from "@/utils/requestApi";

import shopInfo from "./components/shop/index.vue";
import commentItem from "./components/comment-item/index.vue";

export default {
  components: {
    shopInfo,
    commentItem,
  },
  data() {
    return {
      detail: {},
      orderId: "",
      loading: null,
    };
  },
  async created() {
    this.$store.commit("app/setSellerMenuVisible", false);
    this.$store.commit("app/setShowTitle", true);

    const { orderId } = this.$route.query;
    this.orderId = orderId;

    this.loading = this.$loading({
      lock: true,
    });

    const { code, msg, data } = await requestApi.post("sctrading/evaluate/selToEvaluateInfo", {
      orderId,
    });

    this.loading && this.loading.close();

    if (code != "0") {
      this.$message.error(msg);
      return;
    }

    this.detail = data;
  },
};
